export const transformPaginationEvent = (value: {
  current: number;
  perDataCnt: number;
  total?: number;
}): { current: number; perDataCnt: number; total: number } => ({
  current: value.current,
  perDataCnt: value.perDataCnt,
  total: value.total ?? 0,
});

export const extractTextFilterFromChangeFilter = (value: {
  textFilter?: string;
  tokenFilter?: unknown;
  quickFilter?: unknown;
}): string => value.textFilter ?? '';

export const transformSortingEvent = <T>(
  sortingState: Array<{ id: string; desc: boolean }>,
  columns: T[],
  getColumnField: (col: T) => string,
): { order: 'asc' | 'desc' | 'init'; field: string; column: T } | null => {
  if (!sortingState.length) return null;

  const lastSort = sortingState[sortingState.length - 1];
  const column = columns.find((col) => getColumnField(col) === lastSort.id);

  if (!column) return null;

  return {
    order: lastSort.desc ? 'desc' : 'asc',
    field: lastSort.id,
    column,
  };
};

export interface ClickedRowInfoCompat<T> {
  cellIndex: string;
  cellName: string;
  rowData: T;
  rowIndex: number;
  event: MouseEvent;
}

export const removeInternalRowProps = <T extends Record<string, unknown>>(
  row: T & { rowId?: string; isDetail?: boolean },
): T => {
  const { rowId: _rowId, isDetail: _isDetail, ...cleanRow } = row;
  return cleanRow as T;
};

export const transformClickRowEvent = <T extends Record<string, unknown>>(
  rowInfo: {
    event: MouseEvent;
    rowData: T & { rowId?: string; isDetail?: boolean };
    rowIndex: number;
  },
  cellIndex = '',
  cellName = '',
): ClickedRowInfoCompat<T> => ({
  cellIndex,
  cellName,
  event: rowInfo.event,
  rowData: removeInternalRowProps(rowInfo.rowData),
  rowIndex: rowInfo.rowIndex,
});

export const transformClickCellEvent = <T extends Record<string, unknown>>(cellInfo: {
  event: MouseEvent;
  field: string;
  value: unknown;
  row: T & { rowId?: string; isDetail?: boolean };
  rowIndex: number;
  columnIndex: number;
}): { event: MouseEvent; field: string; value: unknown; row: T; cellIndex: number } => ({
  event: cellInfo.event,
  field: cellInfo.field,
  value: cellInfo.value,
  row: removeInternalRowProps(cellInfo.row),
  cellIndex: cellInfo.columnIndex,
});
